import React, { useState, useEffect, useRef, useContext } from "react";
import { isValidHttpUrl, isEmailValid, isPhoneValid } from "../../../utility/input-field-validation";
import TextField from "@mui/material/TextField";
import {Accordion, AccordionDetails, AccordionSummary, Button, Container, InputAdornment, Modal, FormControl, FormLabel, FormGroup, Checkbox, FormControlLabel, Stack} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PublishIcon from "@mui/icons-material/Publish";
import LinkIcon from '@mui/icons-material/Link';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import DeleteForeverIcon from '@mui/icons-material/DeleteForeverRounded';
import LoadingButton from "@mui/lab/LoadingButton";
import PDFsContainerComponent from "../../../components/pdf-container-component/hoa-pool-access-form-pdf-container";
import { GlobalContext } from '../../../context/hoa-global-context';
import config from '../../../hoa-config';
import MultilineRegulationsTextArea from "../../../Container/multiline-regulations-text-area";
import {PictureAsPdf, Attachment} from '@mui/icons-material'
import SourceIdVerificationModal from "./common/SourceIdVerificationModal";
import useFieldDisabled from "../../../hooks/useFieldDisabled";
import EditCancelConfirmationModal from "../../../shared-components/edit-cancel-confirmation";

interface HoaStructureFormProps {
    handleChange : any;
    values: any;
    view: string;
    structureBuildingFiles: any;
    setStructureBuildingFiles: any
    setViolationRegulations: any;
}

export default function HoaStructureForm(props: HoaStructureFormProps) {
    const { violationStructureBuildingFiles, updateViolationStructureBuildingFiles, selectedValues, updateSelectedValues} = useContext<any>(GlobalContext);
    const {handleChange, values, view, structureBuildingFiles, setStructureBuildingFiles, setViolationRegulations} = props;
    const { isStructureFiledDisabled } = useFieldDisabled();

    const stateList : any = {
        structureChangeFiles: [],
        architecturalFiles: [],
        buildingOptions : {},
        regulatedAlterationsOptions: [],
        regulatedMaintenanceOptions: [],
        regulationsOfPainting: '', 
        regulationsOfFence: '', 
        regulationsOfLighting: '', 
        regulationsOfGarageDriveway: '', 
        regulationsOfPavedSurface: '', 
        regulationsOfSwimmingPool: '', 
        regulationsOfPlayscape: '', 
        regulationsOfSecondaryStructure: '', 
        regulationsOfAntennasSatelliteDishes: '', 
        regulationsOfMailboxes: '', 
        regulationsOfOilingExcavationsMiningRainwaterHarvestingSystem: '', 
        regulationsOffLagsFlagPoles: '', 
        regulationsOfWaterFeaturesWellsSepticTanks: '', 
        regulationsOfSidingExteriorCladding: '', 
        regulationsOfWindowsSunScreensScreenDoors: '',
        regulationsOfSecurityDevices: '', 
        regulationsOfCourtyard: '', 
        regulationsOflLawnArtOutdoorFurniture: '',
        regulationsOfBrokenDeterioratingStructure: '', 
        regulationsOfRoofSoffitFascia: '', 
        regulationsOfOutdoorKitchen: '', 
        regulationsOfPatioDeck: '', 
        regulationsOfWindowsAwnings: '', 
        regulationsOfPressureWashing: '', 
        regulationsOfIrrigationSystems: '', 
        regulationsOfDrainage: '',
        regulationsOfSignsAdvertising: '', 
        regulationsOfYardLights: '',
        regulationsOfStorageTanks: '',
        regulationsOfSolarPanels: '',
        regulationsOfAirConditioning: '',
    }

    const [state, setState] = useState(stateList);
    const [expanded1, setExpanded1] = useState(false);
    const [expanded2, setExpanded2] = useState(false);
    const [expanded3, setExpanded3] = useState(false);
    const [open, setOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [sourceFileInfo, setSourceFileInfo] = useState([]);
	const [loading, setLoading] = useState(false);
    const [documentName, setDocumentName] = useState('');
    const [toBeDelete, setToBeDelete] = useState({});
    const [isWaring, setIsWarning] = useState(false);
    const [fieldInfo, setFieldInfo] = useState({
        field: '',
        key: '',
        option: '',
    });

    useEffect(() => {
        if (values) {
            let tempState = { ...state };
            Object.keys(tempState).map((key) => {
                tempState[key] = values[key] || (Array.isArray(tempState[key]) ? [] : typeof tempState[key] === 'object' ? {} : '');
            })
            setState(tempState);
        }
    }, [values])

    useEffect(() => {
        if(structureBuildingFiles.structureChangeFiles.length > 0) {
            setSourceFileInfo(structureBuildingFiles.structureChangeFiles);
        }
    },[])
    
    const handleCurrentChange = (value: any, key: string, checkBoxSelectedKey:string = '', option: string) => {
        let tempState: any = JSON.parse(JSON.stringify(state));
        if(value == null){
            value = "";
        }
        tempState[key] = value;
        if(checkBoxSelectedKey && config[option][checkBoxSelectedKey]) {
            tempState[config[option][checkBoxSelectedKey]] = '';
        }
        setState(tempState);
        handleChange(tempState, 'structure');
    }

    const handleBuildingOptions = (value: any, grandState:string, key: string) => {
        let tempState: any = { ...state };
        tempState[grandState] = {
            ...tempState[grandState],
                [key]: value
            }
        setState(tempState);
        handleChange(tempState, 'structure');
    }

    const handleCheckBoxGroup = (checked: boolean, key: string, stateName : string, option: string) => {
        let tempState: any = JSON.parse(JSON.stringify(state));

        if (!checked && tempState[config[option][key]]) {
            setFieldInfo({
                field: stateName,
                key: key,
                option: option
            });
            setIsWarning(!isWaring);

        } else {
            let tempValue = state[stateName];
            if(checked && !tempValue.includes(key)){
                tempValue.push(key);
            } else if(!checked && tempValue.includes(key)){
                tempValue = tempValue.filter((value: any) => {return value !== key})
            }
            handleCurrentChange(tempValue, stateName, key, option);
        }
    }

    const unCheckWarningYesClick = () => {
        let tempValue = state[fieldInfo.field];
        if(tempValue.includes(fieldInfo.key)){
            tempValue = tempValue.filter((value: any) => {return value !== fieldInfo.key})
        }
        handleCurrentChange(tempValue, fieldInfo.field, fieldInfo.key, fieldInfo.option);
        setIsWarning(false);
    }

    const handleClose = () => {
        setOpen(!open);
    }

    const deleteClick = (document: string, name: any) => {
        setDocumentName(document);
		setToBeDelete(name);
		setOpen(!open);
	}


    const toggleAttachDocumentModal = () => {
        setIsOpen(!isOpen);
        if(sourceFileInfo.length == 0) {
            addNewSourceDocument();
        }
    }
    const addNewSourceDocument = () => {
		const newSource = {
			isVerified: false,
			sourceId: '',
			sourceIdType: ''
		}
		setSourceFileInfo((prev) => [newSource, ...prev]);
	}

    const deleteSourceDocument = (index: number) => {
		setSourceFileInfo((prev) => prev.filter((item, idx) => idx !== index));
        setStructureBuildingFiles((prev: any) => {
            return {
                ...prev,
                structureChangeFiles: prev.structureChangeFiles.filter((item: any, idx: number) => idx !== index)
            }
        });
    }

	const handleSourceFile = (event: any, index: number) => {
		const {name, value} = event.target;
		const tempState = [...sourceFileInfo];
		tempState[index][name] = value;
		if (name === 'files' && value.length > 0) {
			tempState[index]['isVerified'] = true;
        } else if (name === 'files' && value.length == 0) {
			tempState[index]['isVerified'] = false;
        }
		setSourceFileInfo(tempState);
	}

    const onUploadClick = () => {
        if(sourceFileInfo.length > 0) {
            setStructureBuildingFiles({
                    ...structureBuildingFiles,
                    structureChangeFiles: sourceFileInfo
                })
            setIsOpen(!isOpen);
        }
    }
    const isAllVerified = sourceFileInfo.every((item: any) => item.isVerified);

    return (
        <>
            <Accordion
            style={{background: expanded1 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded1(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Alterations
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA"}}>
                <div style={{width: '100%', display:"flex", flexDirection:"column"}}>
                    <FormControl style={{ margin:"12px 0px",  }} component="fieldset" variant="standard" >
                        <FormLabel component="legend">Please select the options which are regulated.</FormLabel>
                        <FormGroup>
                            {
                                 Object.keys(config.alterationOptions).map(key => (
                                    <>
                                        <FormControlLabel
                                            control={
                                            <Checkbox checked={state.regulatedAlterationsOptions.includes(key)} 
                                            onChange={(event) => handleCheckBoxGroup(event.target.checked, key, 'regulatedAlterationsOptions', 'alterationOptions')} 
                                            disabled={isStructureFiledDisabled("regulatedAlterationsOptions") || isStructureFiledDisabled(config.alterationOptions[key])}
                                            />
                                            }
                                            label={key}
                                            />
                                            {
                                                state.regulatedAlterationsOptions.includes(key) &&
                                                <MultilineRegulationsTextArea
                                                    regulationType={config.alterationOptions[key]}
                                                    value={state[config.alterationOptions[key]]}
                                                    handleCurrentChange={handleCurrentChange}
                                                    disabled={
                                                        isStructureFiledDisabled(config.alterationOptions[key])}
                                                />
                                            }
                                    </>
                                 ))
                            }
                            
                        </FormGroup>
                    </FormControl>
                </div>
                </AccordionDetails>
            </Accordion>

            <Accordion
            style={{background: expanded2 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded2(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Building
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA", flexDirection:"column"}}>
                    <FormControl style={{ margin:"12px 0px",  }} component="fieldset" variant="standard" >
                        <FormGroup>
                            <div className="sub-title-text" style={{marginBottom:"24px"}}>Structure Change Application Form</div>
                            <div className="helperText">Upload the application form and links if available.</div>
                            <p>
                                <Button  
                                    startIcon={<Attachment color="primary"/>} 
                                    variant="outlined" 
                                    onClick={toggleAttachDocumentModal}>
                                    Attach Document
                                </Button>
                            </p>
                            {
                                structureBuildingFiles.structureChangeFiles?.length > 0 ?
                                <>
                                <p className="helperText">Selected File :</p>
                                {
                                    Array.from(structureBuildingFiles.structureChangeFiles).map((item: any, index: number)=> (
                                        item.files.map((file: any, indx: number) => (
                                            <div style={{ cursor: "pointer" }} className="ov-pdf-container" >
                                                <Stack direction={"row"} alignItems={"center"}>
                                                    <PictureAsPdf style={{ width: "20px", height: "20px" }} />
                                                    <span style={{ marginLeft: "14px" }} className="text-3E3E3E-14px normal">
                                                        {file}
                                                    </span>
                                                </Stack>
                                            </div>
                                        ))
                                    ))
                                }
                                </>
                                : ''
                            }
                            {
                                state?.structureChangeFiles?.length > 0 ?
                                <>
                                <p className="helperText">Uploaded File :</p>
                                {
                                    Array.from(state?.structureChangeFiles).map((file : any, index: number)=>{
                                        return   <PDFsContainerComponent document={`structureChangeFiles`} deleteClick={deleteClick} view={view} key={index} file={file} path="hoa" folder="structureChangeFiles" />
                                    })
                                }
                                </>
                                : ''
                            }
                            <TextField 
                                style={{ width: "50%" }} 
                                value={state.buildingOptions?.structureHyperLink}
                                onChange={(e) => { handleBuildingOptions(e.target.value, "buildingOptions",  "structureHyperLink") }} 
                                label="Hyper Link" 
                                InputLabelProps={{ style: { fontSize: "14px", margin: "4px" } }}
                                helperText={state?.buildingOptions?.structureHyperLink?.trim().length > 0 && !isValidHttpUrl(state?.buildingOptions?.structureHyperLink as string) ? 'Invalid url format' : ''}
                                error={state?.buildingOptions?.structureHyperLink?.trim().length > 0 && !isValidHttpUrl(state?.buildingOptions?.structureHyperLink as string)}
                                disabled={isStructureFiledDisabled("buildingOptions-structureHyperLink")}
                                variant="standard"
                                InputProps={{
                                    style: { padding:"7px 0px" },
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <LinkIcon />
                                        </InputAdornment>
                            )}} />
                            <div className="sub-title-text" style={{marginTop:"32px"}}>Planning & Building Department Details</div>
                            <div style={{ display: "flex", marginTop: "24px", justifyContent: "flex-start" }}>
                                <TextField 
                                    style={{ width: "45%", marginRight: '10px'}} 
                                    value={state.buildingOptions?.email}
                                    error={!isEmailValid(state.buildingOptions?.email)} 
                                    helperText={!isEmailValid(state.buildingOptions?.email) ? 'Invalid email format' : ''}
                                    onChange={(e) => { handleBuildingOptions(e.target.value, "buildingOptions", "email") }} 
                                    label="Email Address" 
                                    InputLabelProps={{style:{fontSize:"14px"}}}
                                    sx={{'& .MuiInputAdornment-positionEnd': {paddingBottom: '14px'}}}
                                    disabled={isStructureFiledDisabled("buildingOptions-email")}
                                    variant="standard"
                                    InputProps={{
                                        style:{ padding:"7px 0px"},
                                        endAdornment :(
                                            <InputAdornment position="end">
                                                <MailOutlineIcon />
                                            </InputAdornment>
                                )}}/>
                                <TextField 
                                    style={{ width: "45%", }} 
                                    value={state.buildingOptions?.phone}
                                    error={!isPhoneValid(state.buildingOptions?.phone)} 
                                    helperText={!isPhoneValid(state.buildingOptions?.phone) ? 'Invalid number format' : ''}
                                    onChange={(e) => { handleBuildingOptions(e.target.value, "buildingOptions", "phone") }} 
                                    label="Phone Number" 
                                    InputLabelProps={{style:{fontSize:"14px"}}}
                                    sx={{'& .MuiInputAdornment-positionEnd': {paddingBottom: '14px'}}}
                                    disabled={isStructureFiledDisabled("buildingOptions-phone")}
                                    variant="standard"
                                    InputProps={{
                                        style:{ padding:"7px 0px"},
                                        endAdornment :(
                                            <InputAdornment position="end">
                                                <LocalPhoneIcon />
                                            </InputAdornment>
                                )}}/>
                            </div>
                            <div className="sub-title-text" style={{marginTop:"32px"}}>Architectural Instructions</div>
                            <TextField 
                                style={{ width: "75%", marginBottom:"24px"}} 
                                variant="outlined" 
                                value={state.buildingOptions?.instructions}
                                onChange={(e) => { handleBuildingOptions(e.target.value, "buildingOptions", "instructions") }} 
                                label="Write here..." multiline
                                InputLabelProps={{ style: { fontSize: "14px", margin: "5px" } }} 
                                InputProps={{ style: { minHeight:"106px" } }}
                                disabled={isStructureFiledDisabled("buildingOptions-instructions")}
                            />
                        </FormGroup>
                    </FormControl>
                </AccordionDetails>
            </Accordion>

            <Accordion
            style={{background: expanded3 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded3(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Maintenance
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA"}}>
                <div style={{width: '100%', display:"flex", flexDirection:"column"}}>
                    <FormControl style={{ margin:"12px 0px",  }} component="fieldset" variant="standard" >
                        <FormLabel component="legend">Please select the options which are regulated.</FormLabel>
                        <FormGroup>
                            {
                                 Object.keys(config.maintenanceOptions).map(key => (
                                    <>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={state.regulatedMaintenanceOptions.includes(key)} 
                                                onChange={(event) => handleCheckBoxGroup(event.target.checked, key, 'regulatedMaintenanceOptions', 'maintenanceOptions')} 
                                                disabled={isStructureFiledDisabled("regulatedMaintenanceOptions") || isStructureFiledDisabled(config.maintenanceOptions[key])}
                                            />
                                            }
                                            label={key}
                                            />
                                            {
                                                state.regulatedMaintenanceOptions.includes(key) &&
                                                <MultilineRegulationsTextArea
                                                    regulationType={config.maintenanceOptions[key]}
                                                    value={state[config.maintenanceOptions[key]]}
                                                    handleCurrentChange={handleCurrentChange}
                                                    disabled={isStructureFiledDisabled(config.maintenanceOptions[key])}
                                                />
                                            }
                                    </>
                                 ))
                            }
                        </FormGroup>
                    </FormControl>
                </div>
                </AccordionDetails>
            </Accordion>
            <DeleteAttachmentComp
                open={open}
                state={state}
                setState={setState}
                setOpen={setOpen}
                handleClose={handleClose}
                toBeDelete={toBeDelete}
                setToBeDelete={setToBeDelete}
                selectedValues={selectedValues}
                documentName={documentName}
                setDocumentName={setDocumentName}
                setViolationRegulations={setViolationRegulations}
                updateSelectedValues={updateSelectedValues}
                structureBuildingFiles={structureBuildingFiles}
                setStructureBuildingFiles={setStructureBuildingFiles}
                violationStructureBuildingFiles={violationStructureBuildingFiles}
                updateViolationStructureBuildingFiles={updateViolationStructureBuildingFiles}
			/>
            {
                isOpen &&
                <SourceIdVerificationModal 
                    open={isOpen}
                    setOpen={setIsOpen}
                    loading={loading}
                    setLoading={setLoading}
                    handleClose={toggleAttachDocumentModal}
                    addNewSourceDocument={addNewSourceDocument}
                    sourceFileInfo={sourceFileInfo}
                    setSourceFileInfo={setSourceFileInfo}
                    handleSourceFile={handleSourceFile}
                    handleDeleteCard={deleteSourceDocument}
                    isAllVerified={isAllVerified}
                    onUploadClick={onUploadClick}
                />
            }

             <EditCancelConfirmationModal 
                label="Are you sure you want to deselect? Regulation texts will be discarded if you confirm."
                isCancelClicked={isWaring}
                setIsCancelClicked={setIsWarning}
                onCancelYesClick={unCheckWarningYesClick}
            />
        </>
    )
}

const DeleteAttachmentComp = ({
	open,
	setOpen,
    state,
    setState,
	handleClose,
    toBeDelete,
    setToBeDelete,
    documentName,
    setDocumentName,
    selectedValues,
    updateSelectedValues,
    structureBuildingFiles,
    setViolationRegulations,
    setStructureBuildingFiles,
    violationStructureBuildingFiles,
    updateViolationStructureBuildingFiles
}: any) => {
	const [error, setError] = useState({ link: false, files: false });
	const [isLoading, setLoading] = useState(false);

	const handleDelete = async () => {
        if(toBeDelete.name){
            setLoading(true);
            let arr = structureBuildingFiles[documentName].filter((item: any) => {
                return item.name != toBeDelete.name
            })
            setStructureBuildingFiles({
                ...structureBuildingFiles,
                [documentName]: arr
            })
            setToBeDelete({});
            setDocumentName('');
            setLoading(false);
            handleClose();
            return;
        }

        let arr = selectedValues.violationRegulations.structure[documentName].filter((item: any) => {
            return item.fileName != toBeDelete.fileName;
        });
        setLoading(true);
        updateViolationStructureBuildingFiles({
            ...violationStructureBuildingFiles,
            [documentName]: violationStructureBuildingFiles[documentName] ? [...violationStructureBuildingFiles[documentName], toBeDelete] : [toBeDelete]
        })
        selectedValues.violationRegulations.structure[documentName] = arr;
        setState({...state, [documentName]: arr})
        setViolationRegulations(selectedValues.violationRegulations);
        updateSelectedValues(selectedValues);
        arr = [];
        setLoading(false);
        handleClose();
	};

	const onClose = () => {
		handleClose();
	};

	return (
		<Modal open={open} onClose={onClose}>
			<Container className="modal-container-style">
				<div className="modal-wrapper-doc">
					<Stack 
						style={{ 
							alignItems: "center",
							gap: '12px',	
						}}
						direction={"row"}
						spacing={1}
						justifyContent="flex-between">
						<DeleteForeverIcon 
							style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
						<div>
							<h2 style={{color: '#3E3E3E'}}>Are you sure you want to delete?</h2>
							<p style={{color: '#787878'}}>This item will be deleted once you save information. It cannot be retrieved afterward</p>
						</div>
					</Stack>

					<Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
						{!isLoading ? (
							<>
								<Button onClick={() => onClose()} variant="outlined">
									No
								</Button>
								<Button onClick={handleDelete} variant="contained">
									Yes
								</Button>
							</>
						) : (
							<LoadingButton
								loading
								loadingIndicator="Deleting..."
								variant="outlined"
							>
								Deleting Data
							</LoadingButton>
						)}
					</Stack>
				</div>
			</Container>
		</Modal>
	)
}